<template>
  <div
    class="alignments"
    @click.stop
  >
    <span
      v-for="alignedUser in alignedUsers"
      :key="alignedUser.id"
      class="user"
      @click="showModal(alignedUser)"
    >
      {{ alignedUser.nickname || alignedUser.name }}&nbsp;
    </span>
    <a-modal
      v-model:visible="visible"
      width="50%"
      style="top: 0; height: 100%; padding-bottom: 0"
      wrap-class-name="aligned-users-for-performance-modal"
      :footer="null"
      :closable="false"
      :mask-closable="false"
      :destroy-on-close="true"
      @ok="handleOk"
    >
      <modal
        :entity="entity"
        :can-edit="canEdit"
        :aligned-user="alignedUser"
        @close="visible = false"
      />
    </a-modal>
  </div>
</template>

<script>
import { ref } from 'vue'
import Modal from './modal.vue'

export default {
  name: 'AlignedUsersForPerformance',
  components: {
    Modal
  },
  props: {
    alignedUsers: {
      type: Array,
      required: true
    },
    entity: {
      type: Object,
      required: true
    },
    canEdit: {
      type: Boolean,
      default: false
    }
  },
  setup () {
    const visible = ref(false)
    const handleOk = e => {
      visible.value = false
    }

    const alignedUser = ref({})
    const showModal = (val) => {
      visible.value = true
      alignedUser.value = val
    }

    return {
      visible,
      handleOk,
      showModal,
      alignedUser
    }
  }
}
</script>

<style lang="less" scoped>
.alignments {
  position: relative;
  color: rgba(0, 0, 0, .5);
  font-weight: normal;
}
.user {
  cursor: pointer;
  transition: all 0.25s;
  &:hover {
    color: #64b5f6;
  }
}
</style>
<style lang="less">
.aligned-users-for-performance-modal {
  overflow-y: overlay;
  .ant-modal {
    max-width: 100%;
    top: 0;
    left: 25%;
    padding-bottom: 0;
    margin: 0;
  }
  .ant-modal-content {
    display: flex;
    flex-direction: column;
    min-height: calc(100vh);
    background: #F8F9FF;
    border-radius: 8px 8px 0 0;
    .ant-modal-close {
      position: absolute;
      top: 0;
    }
  }
  .ant-modal-body {
    flex: 1;
    padding: 0;
  }
}
</style>
